import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

// Types : comment, like, follow, new_book, plumes, mention
export async function sendNotification({ recipientId, fromId, fromName, type, bookId, bookTitle, message }) {
  if (!recipientId || recipientId === fromId) return; // Pas de notif à soi-même

  await addDoc(collection(db, 'notifications'), {
    recipientId,
    fromId: fromId || null,
    fromName: fromName || 'Plumly',
    type: type || 'info',
    bookId: bookId || null,
    bookTitle: bookTitle || null,
    message: message || null,
    read: false,
    createdAt: serverTimestamp(),
  });
}